<!-- TEMPLATE -->
<template>
  <v-dialog v-model="domain_is_not_set" width="50%" persistent>
    <v-card>
      <v-card-title class="headline">
        <h1>Welcome in Phinix</h1>
      </v-card-title>
      <v-card-text>
        Everything is ready but we need one last information from you to setup
        the environment. Please tell us the domain where you will install the
        Phinix JS agent
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                label="domain.com"
                v-model="domain"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <small>*mandatory</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="ma-1 btn" dark @click="sendDomainList(domain)">
          Send
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<!-- SCRIPT -->
<script>
import PhishingApi from "../app/phishing-api";

export default {
  name: "DialogDomainSet",
  data: function () {
    return {
      userInfo: this.$store.state.cognitoInfo,
      domain: null,
      domains: null,
      domain_is_not_set: false,
    };
  },

  created() {
    let self = this;
    PhishingApi.getDomainList().then(function (value) {
      if (value[0].domain == 0) {
        self.domain_is_not_set = true;
      } else {
        self.domains = value[0].domain;
      }
    });
  },
  methods: {
    sendDomainList(domain) {
      let self = this;
      PhishingApi.setDomainList(domain).then(function (value) {
        self.domain_is_not_set = false;
      });
    },
  },
};
</script>

<!-- Style -->
<style>
</style>